module.exports = __webpack_public_path__ + "static/media/decade-grid-3.55a5ec36.png";